import MarkersAssessed from "@/components/reports/MarkersAssessed";
import MarkersAssessedChart from "@/components/reports/MarkersAssessedChart";
import Stack from "@/tpo/Stack";

export default function TestsTabContent({ report, userReport }) {
  return (
    <Stack gap={40}>
      {userReport && (
        <MarkersAssessedChart
          snpCounts={{
            inRange: userReport?.dnaDatapointCounts?.inRangeCount || 0,
            outOfRange: userReport?.dnaDatapointCounts?.outOfRangeCount || 0,
            untested: userReport?.dnaDatapointCounts?.untestedCount || 0
          }}
          functionalCounts={{
            inRange: userReport?.functionalDatapointCounts?.inRangeCount || 0,
            outOfRange: userReport?.functionalDatapointCounts?.outOfRangeCount || 0,
            untested: userReport?.functionalDatapointCounts?.untestedCount || 0
          }}
          symptomCounts={{
            inRange: userReport?.questionsAndAnswersCounts?.inRangeCount || 0,
            outOfRange: userReport?.questionsAndAnswersCounts?.outOfRangeCount || 0,
            untested: userReport?.questionsAndAnswersCounts?.untestedCount || 0
          }}
          sx={{
            maxWidth: 720,
            width: "100%",
            mx: "auto"
          }}
        />
      )}
      <MarkersAssessed markers={report?.assessedDatapoints || []} />
    </Stack>
  );
}
